import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactApp from './app/ReactApp';

// include OIDC client in React bundle (sets window.getUserManager)
import './services/oidcClient';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element — cannot mount Ministry Grid');
}

createRoot(rootEl).render(<ReactApp />);
